import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class Share extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { 
                /* tslint:disable-next-line */
                d: "M11 12L12 11V14H0V4H1V13H11V12ZM10 8C9.33333 8 8.67969 8.06771 8.03906 8.20312C7.40365 8.33333 6.78906 8.52865 6.19531 8.78906C5.60156 9.04427 5.03385 9.35938 4.49219 9.73438C3.95573 10.1042 3.45833 10.526 3 11V10C3 9.35417 3.08333 8.73438 3.25 8.14062C3.41667 7.54167 3.65104 6.98438 3.95312 6.46875C4.26042 5.94792 4.625 5.47656 5.04688 5.05469C5.47396 4.6276 5.94531 4.26302 6.46094 3.96094C6.98177 3.65365 7.53906 3.41667 8.13281 3.25C8.73177 3.08333 9.35417 3 10 3V0L15.5 5.5L10 11V8ZM10.7891 4C10.4974 4 10.224 4.0026 9.96875 4.00781C9.71354 4.01302 9.46094 4.03125 9.21094 4.0625C8.96094 4.08854 8.71094 4.13542 8.46094 4.20312C8.21094 4.26562 7.94531 4.35417 7.66406 4.46875C7.21094 4.65625 6.78906 4.89583 6.39844 5.1875C6.01302 5.47917 5.66667 5.8125 5.35938 6.1875C5.05729 6.55729 4.79948 6.96094 4.58594 7.39844C4.3776 7.83073 4.22396 8.28646 4.125 8.76562C5 8.18229 5.9349 7.74219 6.92969 7.44531C7.92448 7.14844 8.94792 7 10 7H11V8.58594L14.0859 5.5L11 2.41406V4H10.7891Z" })));
    }
}
